export default __webpack_public_path__ + "static/media/water_col.3824902e.jpg";